/* Dev mapping: quiz result id -> catalog shelf. Generated by build_result_map.py */
window.RITE_RESULT_MAP = {
  "lenin": {
    "photo": "lenin",
    "role": "Revolutionary, 1917–1924",
    "idea": "Marxism-Leninism / the party-state",
    "bio": "Lenin treated the state as a weapon, not a seminar. What Is To Be Done, State and Revolution, Imperialism — then the party that actually took the Winter Palace. If this is your region of the map, start with the communism bundle, then the short manuals he and Stalin used.",
    "bundle": "the-communism-bundle",
    "start": "state-and-revolution-revised",
    "more": [
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "fascism-what-it-is-and-how-to-fight-it"
    ]
  },
  "stalin": {
    "photo": "stalin",
    "role": "General Secretary, USSR",
    "idea": "Administered Marxism-Leninism",
    "bio": "Stalin is what happens when the left stops debating and starts planning. Foundations of Leninism is the pocket manual. The communism bundle is the shelf. Mao is the next door if you want the peasant-cadre version.",
    "bundle": "the-communism-bundle",
    "start": "foundations-of-leninism",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "marx": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "goldman": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "nietzsche": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  },
  "evola": {
    "photo": "evola",
    "role": "Traditionalist",
    "idea": "Caste, rite, riding the Kali Yuga",
    "bio": "Evola is politics downstream of a spiritual climate. Revolt Against the Modern World and Ride the Tiger are the two doors; the Evola bundle is the shelf. Guénon is the metaphysician beside him.",
    "bundle": "the-essential-evola-bundle",
    "start": "revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga",
    "more": [
      "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul",
      "men-among-the-ruins-postwar-reflections-of-a-radical-traditionalist",
      "doctrine-of-awakening-the-attainment-of-self-mastery-according-to-the-earliest-buddhist-texts",
      "the-crisis-of-the-modern-world"
    ]
  },
  "guenon": {
    "photo": "guenon",
    "role": "Metaphysician",
    "idea": "The modern world as a rupture",
    "bio": "Guénon is not a campaign. The Crisis of the Modern World is the short book. Evola is the political traditionalist who took the same diagnosis into the street.",
    "bundle": "the-essential-evola-bundle",
    "start": "the-crisis-of-the-modern-world",
    "more": [
      "revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga",
      "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul",
      "men-among-the-ruins-postwar-reflections-of-a-radical-traditionalist",
      "doctrine-of-awakening-the-attainment-of-self-mastery-according-to-the-earliest-buddhist-texts"
    ]
  },
  "yockey": {
    "photo": "yockey",
    "role": "Theorist of Imperium",
    "idea": "The West as a subject, not a market",
    "bio": "Yockey wrote Imperium in 1948 as a philosophy of history with a political will. The Yockey bundle is the shelf. Spengler is the civilizational science underneath it.",
    "bundle": "the-francis-p-yockey-bundle",
    "start": "imperium-the-philosophy-of-history-and-politics",
    "more": [
      "lost-writings-of-francis-parker-yockey",
      "world-in-flames-the-shorter-writings-of-francis-parker-yockey",
      "enemy-of-europe",
      "decline-of-the-west-two-volumes-in-one",
      "decline-of-the-west-two-volumes-in-one",
      "prussianism-and-socialism"
    ]
  },
  "spengler": {
    "photo": "spengler",
    "role": "Philosopher of history",
    "idea": "Cultures as living forms",
    "bio": "Decline of the West is the big book; Prussianism and Socialism is the political short. The Spengler bundle is the shelf. Yockey and Jünger sit next to him.",
    "bundle": "the-spengler-bundle",
    "start": "decline-of-the-west-two-volumes-in-one",
    "more": [
      "prussianism-and-socialism",
      "imperium-the-philosophy-of-history-and-politics",
      "the-ernst-junger-bundle",
      "the-ernst-junger-bundle"
    ]
  },
  "jung": {
    "photo": "jung",
    "role": "Psychologist",
    "idea": "Shadow, self, the interior as territory",
    "bio": "Jung treats politics as a symptom. Modern Man in Search of a Soul is the readable door; the Jung bundle is the shelf. Kierkegaard is the neighboring demand on the single individual.",
    "bundle": "the-carl-jung-bundle",
    "start": "modern-man-in-search-of-a-soul",
    "more": [
      "psychology-of-the-unconscious",
      "red-book-a-reader-s-edition",
      "the-sickness-unto-death"
    ]
  },
  "aurelius": {
    "photo": "aurelius",
    "role": "Emperor, Stoic",
    "idea": "Duty, inner rule, a state that holds",
    "bio": "Meditations is the book. The Stoic bundle is the shelf. The Prince is the colder manual of the same problem: how to govern when the age is not helping you.",
    "bundle": "the-stoic-bundle",
    "start": "meditations-complete-and-unabridged",
    "more": [
      "consolation-of-philosophy",
      "the-prince-second-edition"
    ]
  },
  "gaddafi": {
    "photo": "gaddafi",
    "role": "Head of state, Libya 1969–2011",
    "idea": "Third position / Jamahiriya",
    "bio": "Gaddafi tried to write a system that was neither Moscow nor the IMF, then run a country with it. The Green Book is the primary text — short, odd, and the actual document. There is no Gaddafi bundle. The European third-position shelf is the next table: Mosley, Mussolini, José Antonio, Dugin's Fourth Political Theory, Faye. The Fash bundle is the fastest way onto that table.",
    "bundle": "the-fash-bundle",
    "start": "gaddafi-s-the-green-book",
    "more": [
      "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1",
      "the-archeo-futurist-bundle"
    ]
  },
  "mussolini": {
    "photo": "mussolini",
    "role": "Duce, Italy",
    "idea": "Fascism as state, syndicate, spectacle",
    "bio": "The speeches are the source, not the later costume. Voce del Popolo is the primary text we stock. The Fash bundle is the shelf. José Antonio, Mosley, and the Spanish war sit next to him.",
    "bundle": "the-fash-bundle",
    "start": "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
    "more": [
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1"
    ]
  },
  "mao": {
    "photo": "mao",
    "role": "Chairman, PRC",
    "idea": "Peasant revolution, cadre, little book",
    "bio": "The Little Red Book is the pocket document. Lenin and Stalin are the prior manuals. The communism bundle is the shelf.",
    "bundle": "the-communism-bundle",
    "start": "little-red-book-sayings-of-chairman-mao",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed"
    ]
  },
  "hitler": {
    "photo": "hitler",
    "role": "Chancellor, 1933–1945",
    "idea": "National Socialism as program",
    "bio": "If this is the match, read the primary texts as documents. Mein Kampf and the speeches are what we stock. The Man Against Time bundle is the shelf. This is not a costume quiz.",
    "bundle": "the-man-against-time-bundle",
    "start": "mein-kampf-complete-edition",
    "more": [
      "in-his-own-words-the-essential-speeches-of-adolf-hitler-7129",
      "voice-of-triumph-hitler-s-speeches-at-nuremberg",
      "rise-of-the-nsdap",
      "national-socialism-a-comprehensive-examination",
      "myth-of-the-20th-century"
    ]
  },
  "kierkegaard": {
    "photo": "kierkegaard",
    "role": "Philosopher",
    "idea": "The demand addressed to you, specifically",
    "bio": "The Sickness Unto Death is the book we stock. Jung and Nietzsche are the neighboring interiors. There is no Kierkegaard bundle yet.",
    "bundle": null,
    "start": "the-sickness-unto-death",
    "more": [
      "modern-man-in-search-of-a-soul",
      "psychology-of-the-unconscious",
      "red-book-a-reader-s-edition",
      "beyond-good-and-evil",
      "thus-spake-zarathustra-a-book-for-all-and-none"
    ]
  },
  "mosley": {
    "photo": "mosley",
    "role": "Leader, British Union of Fascists",
    "idea": "British fascism",
    "bio": "BUF is the primary text we stock on Mosley. The Fash bundle is the shelf. Mussolini is the continental original.",
    "bundle": "the-fash-bundle",
    "start": "buf-oswald-mosley-and-british-fascism",
    "more": [
      "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
      "jose-antonio-fascist",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1"
    ]
  },
  "bolsheviks": {
    "photo": "lenin",
    "role": "The Bolsheviks",
    "idea": "Party, class, the seizure of the state",
    "bio": "They would have called you unreliable. If you want to hear them, the communism bundle is the shelf — Lenin and Stalin in their own words, not a later morality play.",
    "bundle": "the-communism-bundle",
    "start": "state-and-revolution-revised",
    "more": [
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "traditionalists": {
    "photo": "guenon",
    "role": "The Traditionalists",
    "idea": "Rite, caste, the vertical",
    "bio": "They would have found you too modern. Guénon and Evola are the indictment. The Evola bundle is the shelf.",
    "bundle": "the-essential-evola-bundle",
    "start": "the-crisis-of-the-modern-world",
    "more": [
      "revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga",
      "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul",
      "men-among-the-ruins-postwar-reflections-of-a-radical-traditionalist",
      "doctrine-of-awakening-the-attainment-of-self-mastery-according-to-the-earliest-buddhist-texts"
    ]
  },
  "anarchists": {
    "photo": "goldman",
    "role": "The Anarchists",
    "idea": "No state, including yours",
    "bio": "You still want a flag or a plan. Goldman's essays are the case against you.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised"
    ]
  },
  "fascists": {
    "photo": "mussolini",
    "role": "The Fascists",
    "idea": "Nation, will, the choir",
    "bio": "They would have called you a liberal. The speeches and the Fash bundle are the other side of that insult.",
    "bundle": "the-fash-bundle",
    "start": "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
    "more": [
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1"
    ]
  },
  "jacobins": {
    "photo": "chesterton",
    "role": "The Jacobins",
    "idea": "Year one, against the old world",
    "bio": "You kept too much of the old world. Chesterton and the death-of-the-West shelf are how that argument still prints.",
    "bundle": "the-christian-nationalism-bundle",
    "start": "what-s-wrong-with-the-world",
    "more": [
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ",
      "death-of-the-west-how-dying-populations-and-immigrant-invasions-imperil-our-country-and-civilization",
      "suicide-of-a-superpower-will-america-survive-to-2025",
      "camp-of-the-saints",
      "why-i-am-not-a-liberal-imperium-press-studies-in-reaction"
    ]
  },
  "liberals": {
    "photo": "chesterton",
    "role": "The progressives",
    "idea": "The decade as a moral law",
    "bio": "You will not perform the decade. Buchanan, Camp of the Saints, and the Christian-nationalism shelf are the open-text argument.",
    "bundle": "america-first-pat-buchanan-bundle",
    "start": "death-of-the-west-how-dying-populations-and-immigrant-invasions-imperil-our-country-and-civilization",
    "more": [
      "suicide-of-a-superpower-will-america-survive-to-2025",
      "camp-of-the-saints",
      "why-i-am-not-a-liberal-imperium-press-studies-in-reaction",
      "what-s-wrong-with-the-world",
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ",
      "harassment-architecture"
    ]
  },
  "futurists": {
    "photo": "mishima",
    "role": "The Futurists",
    "idea": "Speed, machines, the bonfire of museums",
    "bio": "You sit still. Mishima and Jünger are what a serious man reads instead of a manifesto about velocity. The warrior-philosopher bundle is the shelf.",
    "bundle": "the-warrior-philosopher-bundle",
    "start": "sun-and-steel",
    "more": [
      "storm-of-steel-penguin-classics-deluxe-edition",
      "the-mishima-bundle",
      "the-ernst-junger-bundle"
    ]
  },
  "fascism": {
    "photo": "mussolini",
    "role": "Duce, Italy",
    "idea": "Fascism as state, syndicate, spectacle",
    "bio": "The speeches are the source, not the later costume. Voce del Popolo is the primary text we stock. The Fash bundle is the shelf. José Antonio, Mosley, and the Spanish war sit next to him.",
    "bundle": "the-fash-bundle",
    "start": "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
    "more": [
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1"
    ]
  },
  "british-fascism": {
    "photo": "mosley",
    "role": "Leader, British Union of Fascists",
    "idea": "British fascism",
    "bio": "BUF is the primary text we stock on Mosley. The Fash bundle is the shelf. Mussolini is the continental original.",
    "bundle": "the-fash-bundle",
    "start": "buf-oswald-mosley-and-british-fascism",
    "more": [
      "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
      "jose-antonio-fascist",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1"
    ]
  },
  "national-socialism": {
    "photo": "hitler",
    "role": "Chancellor, 1933–1945",
    "idea": "National Socialism as program",
    "bio": "If this is the match, read the primary texts as documents. Mein Kampf and the speeches are what we stock. The Man Against Time bundle is the shelf. This is not a costume quiz.",
    "bundle": "the-man-against-time-bundle",
    "start": "mein-kampf-complete-edition",
    "more": [
      "in-his-own-words-the-essential-speeches-of-adolf-hitler-7129",
      "voice-of-triumph-hitler-s-speeches-at-nuremberg",
      "rise-of-the-nsdap",
      "national-socialism-a-comprehensive-examination",
      "myth-of-the-20th-century"
    ]
  },
  "italian-fascism": {
    "photo": "mussolini",
    "role": "Duce, Italy",
    "idea": "Fascism as state, syndicate, spectacle",
    "bio": "The speeches are the source, not the later costume. Voce del Popolo is the primary text we stock. The Fash bundle is the shelf. José Antonio, Mosley, and the Spanish war sit next to him.",
    "bundle": "the-fash-bundle",
    "start": "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
    "more": [
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1"
    ]
  },
  "prussian-socialism": {
    "photo": "spengler",
    "role": "Prussian Socialism",
    "idea": "Duty, the state, not Manchester",
    "bio": "Spengler's political short. Decline of the West is the big book; the Spengler bundle is the shelf. Yockey is the American who took it further.",
    "bundle": "the-spengler-bundle",
    "start": "prussianism-and-socialism",
    "more": [
      "decline-of-the-west-two-volumes-in-one",
      "imperium-the-philosophy-of-history-and-politics",
      "the-ernst-junger-bundle",
      "imperium-the-philosophy-of-history-and-politics",
      "lost-writings-of-francis-parker-yockey"
    ]
  },
  "integralism": {
    "photo": "chesterton",
    "role": "Integralism",
    "idea": "Throne and altar as one problem",
    "bio": "Christian order as politics. Chesterton is the readable English door; the Christian nationalism bundle is the shelf.",
    "bundle": "the-christian-nationalism-bundle",
    "start": "what-s-wrong-with-the-world",
    "more": [
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ"
    ]
  },
  "distributism": {
    "photo": "chesterton",
    "role": "Distributism",
    "idea": "Property widely held, against both boss and commissar",
    "bio": "Chesterton's What's Wrong with the World is the door. The Christian nationalism bundle is the nearest shelf we have.",
    "bundle": "the-christian-nationalism-bundle",
    "start": "what-s-wrong-with-the-world",
    "more": [
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ"
    ]
  },
  "falangism": {
    "photo": "mussolini",
    "role": "Falangism",
    "idea": "José Antonio, Spain, the syndical nation",
    "bio": "José Antonio, Fascist is the primary text. Spain 1923–48 and the Fash bundle sit next to it.",
    "bundle": "the-fash-bundle",
    "start": "jose-antonio-fascist",
    "more": [
      "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
      "buf-oswald-mosley-and-british-fascism",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1",
      "spain-1923-48-civil-war-and-world-war"
    ]
  },
  "strasserism": {
    "photo": "hitler",
    "role": "Strasserism",
    "idea": "The left-faction of German fascism",
    "bio": "We don't stock a Strasser primary. The NS shelf and the Fash bundle are the neighboring documents — read them as the fight inside that camp, not as a costume.",
    "bundle": "the-man-against-time-bundle",
    "start": "national-socialism-a-comprehensive-examination",
    "more": [
      "mein-kampf-complete-edition",
      "in-his-own-words-the-essential-speeches-of-adolf-hitler-7129",
      "voice-of-triumph-hitler-s-speeches-at-nuremberg",
      "rise-of-the-nsdap",
      "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist"
    ]
  },
  "legionarism": {
    "photo": "evola",
    "role": "Legionarism",
    "idea": "Mystical nationalism, sacrifice, the Iron Guard climate",
    "bio": "No Codreanu primary in the catalog. Evola and the Fash/NS shelves are the neighboring climate.",
    "bundle": "the-essential-evola-bundle",
    "start": "men-among-the-ruins-postwar-reflections-of-a-radical-traditionalist",
    "more": [
      "revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga",
      "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul",
      "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist"
    ]
  },
  "juche": {
    "photo": "mao",
    "role": "Juche",
    "idea": "Autarky, the leader, the fortress-state",
    "bio": "No Kim primary. Mao's Little Red Book and the communism shelf are the neighboring manuals. Gaddafi is the other third-world third position we actually stock.",
    "bundle": "the-communism-bundle",
    "start": "little-red-book-sayings-of-chairman-mao",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "gaddafi-s-the-green-book"
    ]
  },
  "folkish-vitalism": {
    "photo": "evola",
    "role": "Folkish Vitalism",
    "idea": "Blood, rite, life against the last man",
    "bio": "Evola and the NS/Thule shelf. Ride the Tiger and Revolt are the doors we stock.",
    "bundle": "the-essential-evola-bundle",
    "start": "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul",
    "more": [
      "revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga",
      "men-among-the-ruins-postwar-reflections-of-a-radical-traditionalist",
      "doctrine-of-awakening-the-attainment-of-self-mastery-according-to-the-earliest-buddhist-texts",
      "the-crisis-of-the-modern-world",
      "mein-kampf-complete-edition",
      "in-his-own-words-the-essential-speeches-of-adolf-hitler-7129",
      "voice-of-triumph-hitler-s-speeches-at-nuremberg"
    ]
  },
  "marxism-leninism": {
    "photo": "lenin",
    "role": "Revolutionary, 1917–1924",
    "idea": "Marxism-Leninism / the party-state",
    "bio": "Lenin treated the state as a weapon, not a seminar. What Is To Be Done, State and Revolution, Imperialism — then the party that actually took the Winter Palace. If this is your region of the map, start with the communism bundle, then the short manuals he and Stalin used.",
    "bundle": "the-communism-bundle",
    "start": "state-and-revolution-revised",
    "more": [
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "fascism-what-it-is-and-how-to-fight-it"
    ]
  },
  "orthodox-marxism": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "eco-marxism": {
    "photo": "marx",
    "role": "Eco-Marxism",
    "idea": "Class plus the mill's exhaust",
    "bio": "Marx remains the door. The communism bundle is the shelf. No standalone ecology title — Land/Kaczynski sit on a different, anti-industrial table if that's the real lean.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "industrial-society-and-its-future"
    ]
  },
  "centrist-marxism": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "council-communism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "left-communism": {
    "photo": "lenin",
    "role": "Revolutionary, 1917–1924",
    "idea": "Marxism-Leninism / the party-state",
    "bio": "Lenin treated the state as a weapon, not a seminar. What Is To Be Done, State and Revolution, Imperialism — then the party that actually took the Winter Palace. If this is your region of the map, start with the communism bundle, then the short manuals he and Stalin used.",
    "bundle": "the-communism-bundle",
    "start": "state-and-revolution-revised",
    "more": [
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "fascism-what-it-is-and-how-to-fight-it"
    ]
  },
  "anarcho-communism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "eco-anarchism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "market-anarchism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "utopian-socialism": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "democratic-socialism": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "social-democracy": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "left-wing-nationalism": {
    "photo": "stalin",
    "role": "Left-wing nationalism",
    "idea": "Class plus the people as a unit",
    "bio": "Stalin and Mao are the historical manuals. The communism bundle is the shelf. Yockey is the right-hand version of 'the people as subject.'",
    "bundle": "the-communism-bundle",
    "start": "foundations-of-leninism",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "imperium-the-philosophy-of-history-and-politics",
      "lost-writings-of-francis-parker-yockey"
    ]
  },
  "chesterton": {
    "photo": "chesterton",
    "role": "Writer",
    "idea": "Property, the family, against both boss and commissar",
    "bio": "What's Wrong with the World is the door. The Christian nationalism bundle is the shelf.",
    "bundle": "the-christian-nationalism-bundle",
    "start": "what-s-wrong-with-the-world",
    "more": [
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ"
    ]
  },
  "libertarian-communism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "trotskyism": {
    "photo": "lenin",
    "role": "Revolutionary, 1917–1924",
    "idea": "Marxism-Leninism / the party-state",
    "bio": "Lenin treated the state as a weapon, not a seminar. What Is To Be Done, State and Revolution, Imperialism — then the party that actually took the Winter Palace. If this is your region of the map, start with the communism bundle, then the short manuals he and Stalin used.",
    "bundle": "the-communism-bundle",
    "start": "state-and-revolution-revised",
    "more": [
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "fascism-what-it-is-and-how-to-fight-it"
    ]
  },
  "marxism": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "de-leonism": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "leninism": {
    "photo": "lenin",
    "role": "Revolutionary, 1917–1924",
    "idea": "Marxism-Leninism / the party-state",
    "bio": "Lenin treated the state as a weapon, not a seminar. What Is To Be Done, State and Revolution, Imperialism — then the party that actually took the Winter Palace. If this is your region of the map, start with the communism bundle, then the short manuals he and Stalin used.",
    "bundle": "the-communism-bundle",
    "start": "state-and-revolution-revised",
    "more": [
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "fascism-what-it-is-and-how-to-fight-it"
    ]
  },
  "stalinism-maoism": {
    "photo": "stalin",
    "role": "General Secretary, USSR",
    "idea": "Administered Marxism-Leninism",
    "bio": "Stalin is what happens when the left stops debating and starts planning. Foundations of Leninism is the pocket manual. The communism bundle is the shelf. Mao is the next door if you want the peasant-cadre version.",
    "bundle": "the-communism-bundle",
    "start": "foundations-of-leninism",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "religious-communism": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "state-socialism": {
    "photo": "lenin",
    "role": "Revolutionary, 1917–1924",
    "idea": "Marxism-Leninism / the party-state",
    "bio": "Lenin treated the state as a weapon, not a seminar. What Is To Be Done, State and Revolution, Imperialism — then the party that actually took the Winter Palace. If this is your region of the map, start with the communism bundle, then the short manuals he and Stalin used.",
    "bundle": "the-communism-bundle",
    "start": "state-and-revolution-revised",
    "more": [
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "fascism-what-it-is-and-how-to-fight-it"
    ]
  },
  "theocratic-socialism": {
    "photo": "chesterton",
    "role": "Writer",
    "idea": "Property, the family, against both boss and commissar",
    "bio": "What's Wrong with the World is the door. The Christian nationalism bundle is the shelf.",
    "bundle": "the-christian-nationalism-bundle",
    "start": "what-s-wrong-with-the-world",
    "more": [
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ"
    ]
  },
  "religious-socialism": {
    "photo": "chesterton",
    "role": "Writer",
    "idea": "Property, the family, against both boss and commissar",
    "bio": "What's Wrong with the World is the door. The Christian nationalism bundle is the shelf.",
    "bundle": "the-christian-nationalism-bundle",
    "start": "what-s-wrong-with-the-world",
    "more": [
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ"
    ]
  },
  "revolutionary-socialism": {
    "photo": "lenin",
    "role": "Revolutionary, 1917–1924",
    "idea": "Marxism-Leninism / the party-state",
    "bio": "Lenin treated the state as a weapon, not a seminar. What Is To Be Done, State and Revolution, Imperialism — then the party that actually took the Winter Palace. If this is your region of the map, start with the communism bundle, then the short manuals he and Stalin used.",
    "bundle": "the-communism-bundle",
    "start": "state-and-revolution-revised",
    "more": [
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao",
      "fascism-what-it-is-and-how-to-fight-it"
    ]
  },
  "libertarian-socialism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "anarcho-syndicalism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "left-wing-populism": {
    "photo": "marx",
    "role": "Philosopher of capital",
    "idea": "Class, property, historical materialism",
    "bio": "Marx is the analysis, not yet the police. Philosophy of Marx and the Manifesto are the door; the communism bundle is the room. Lenin is what you read when you want to know who picks up the gun.",
    "bundle": "the-communism-bundle",
    "start": "philosophy-of-marx",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "theocratic-distributism": {
    "photo": "chesterton",
    "role": "Writer",
    "idea": "Property, the family, against both boss and commissar",
    "bio": "What's Wrong with the World is the door. The Christian nationalism bundle is the shelf.",
    "bundle": "the-christian-nationalism-bundle",
    "start": "what-s-wrong-with-the-world",
    "more": [
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ"
    ]
  },
  "social-liberalism": {
    "photo": "aurelius",
    "role": "Emperor, Stoic",
    "idea": "Duty, inner rule, a state that holds",
    "bio": "Meditations is the book. The Stoic bundle is the shelf. The Prince is the colder manual of the same problem: how to govern when the age is not helping you.",
    "bundle": "the-stoic-bundle",
    "start": "meditations-complete-and-unabridged",
    "more": [
      "consolation-of-philosophy",
      "the-prince-second-edition"
    ]
  },
  "christian-democracy": {
    "photo": "chesterton",
    "role": "Writer",
    "idea": "Property, the family, against both boss and commissar",
    "bio": "What's Wrong with the World is the door. The Christian nationalism bundle is the shelf.",
    "bundle": "the-christian-nationalism-bundle",
    "start": "what-s-wrong-with-the-world",
    "more": [
      "the-last-superstition-a-refutation-of-the-new-atheism",
      "sword-of-christ"
    ]
  },
  "progressivism": {
    "photo": "jung",
    "role": "Psychologist",
    "idea": "Shadow, self, the interior as territory",
    "bio": "Jung treats politics as a symptom. Modern Man in Search of a Soul is the readable door; the Jung bundle is the shelf. Kierkegaard is the neighboring demand on the single individual.",
    "bundle": "the-carl-jung-bundle",
    "start": "modern-man-in-search-of-a-soul",
    "more": [
      "psychology-of-the-unconscious",
      "red-book-a-reader-s-edition",
      "the-sickness-unto-death"
    ]
  },
  "anarcho-mutualism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "national-totalitarianism": {
    "photo": "hitler",
    "role": "Chancellor, 1933–1945",
    "idea": "National Socialism as program",
    "bio": "If this is the match, read the primary texts as documents. Mein Kampf and the speeches are what we stock. The Man Against Time bundle is the shelf. This is not a costume quiz.",
    "bundle": "the-man-against-time-bundle",
    "start": "mein-kampf-complete-edition",
    "more": [
      "in-his-own-words-the-essential-speeches-of-adolf-hitler-7129",
      "voice-of-triumph-hitler-s-speeches-at-nuremberg",
      "rise-of-the-nsdap",
      "national-socialism-a-comprehensive-examination",
      "myth-of-the-20th-century"
    ]
  },
  "global-totalitarianism": {
    "photo": "mao",
    "role": "Chairman, PRC",
    "idea": "Peasant revolution, cadre, little book",
    "bio": "The Little Red Book is the pocket document. Lenin and Stalin are the prior manuals. The communism bundle is the shelf.",
    "bundle": "the-communism-bundle",
    "start": "little-red-book-sayings-of-chairman-mao",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed"
    ]
  },
  "technocracy": {
    "photo": "spengler",
    "role": "Philosopher of history",
    "idea": "Cultures as living forms",
    "bio": "Decline of the West is the big book; Prussianism and Socialism is the political short. The Spengler bundle is the shelf. Yockey and Jünger sit next to him.",
    "bundle": "the-spengler-bundle",
    "start": "decline-of-the-west-two-volumes-in-one",
    "more": [
      "prussianism-and-socialism",
      "imperium-the-philosophy-of-history-and-politics",
      "the-ernst-junger-bundle",
      "the-ernst-junger-bundle"
    ]
  },
  "centrist": {
    "photo": "aurelius",
    "role": "Emperor, Stoic",
    "idea": "Duty, inner rule, a state that holds",
    "bio": "Meditations is the book. The Stoic bundle is the shelf. The Prince is the colder manual of the same problem: how to govern when the age is not helping you.",
    "bundle": "the-stoic-bundle",
    "start": "meditations-complete-and-unabridged",
    "more": [
      "consolation-of-philosophy",
      "the-prince-second-edition"
    ]
  },
  "liberalism": {
    "photo": "aurelius",
    "role": "Emperor, Stoic",
    "idea": "Duty, inner rule, a state that holds",
    "bio": "Meditations is the book. The Stoic bundle is the shelf. The Prince is the colder manual of the same problem: how to govern when the age is not helping you.",
    "bundle": "the-stoic-bundle",
    "start": "meditations-complete-and-unabridged",
    "more": [
      "consolation-of-philosophy",
      "the-prince-second-edition"
    ]
  },
  "religious-anarchism": {
    "photo": "goldman",
    "role": "Anarchist",
    "idea": "Anti-capital and anti-commissar",
    "bio": "Goldman wanted the workers without the Cheka. Anarchism and Other Essays is the primary text we stock. Marx still belongs on the same table; Lenin is the argument she lost.",
    "bundle": null,
    "start": "anarchism-and-other-essays",
    "more": [
      "philosophy-of-marx",
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "foundations-of-leninism"
    ]
  },
  "right-wing-populism": {
    "photo": "yockey",
    "role": "Theorist of Imperium",
    "idea": "The West as a subject, not a market",
    "bio": "Yockey wrote Imperium in 1948 as a philosophy of history with a political will. The Yockey bundle is the shelf. Spengler is the civilizational science underneath it.",
    "bundle": "the-francis-p-yockey-bundle",
    "start": "imperium-the-philosophy-of-history-and-politics",
    "more": [
      "lost-writings-of-francis-parker-yockey",
      "world-in-flames-the-shorter-writings-of-francis-parker-yockey",
      "enemy-of-europe",
      "decline-of-the-west-two-volumes-in-one",
      "decline-of-the-west-two-volumes-in-one",
      "prussianism-and-socialism"
    ]
  },
  "moderate-conservatism": {
    "photo": "aurelius",
    "role": "Emperor, Stoic",
    "idea": "Duty, inner rule, a state that holds",
    "bio": "Meditations is the book. The Stoic bundle is the shelf. The Prince is the colder manual of the same problem: how to govern when the age is not helping you.",
    "bundle": "the-stoic-bundle",
    "start": "meditations-complete-and-unabridged",
    "more": [
      "consolation-of-philosophy",
      "the-prince-second-edition"
    ]
  },
  "reactionary": {
    "photo": "evola",
    "role": "Traditionalist",
    "idea": "Caste, rite, riding the Kali Yuga",
    "bio": "Evola is politics downstream of a spiritual climate. Revolt Against the Modern World and Ride the Tiger are the two doors; the Evola bundle is the shelf. Guénon is the metaphysician beside him.",
    "bundle": "the-essential-evola-bundle",
    "start": "revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga",
    "more": [
      "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul",
      "men-among-the-ruins-postwar-reflections-of-a-radical-traditionalist",
      "doctrine-of-awakening-the-attainment-of-self-mastery-according-to-the-earliest-buddhist-texts",
      "the-crisis-of-the-modern-world"
    ]
  },
  "social-libertarianism": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  },
  "libertarianism": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  },
  "anarcho-egoism": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  },
  "nazism": {
    "photo": "hitler",
    "role": "Chancellor, 1933–1945",
    "idea": "National Socialism as program",
    "bio": "If this is the match, read the primary texts as documents. Mein Kampf and the speeches are what we stock. The Man Against Time bundle is the shelf. This is not a costume quiz.",
    "bundle": "the-man-against-time-bundle",
    "start": "mein-kampf-complete-edition",
    "more": [
      "in-his-own-words-the-essential-speeches-of-adolf-hitler-7129",
      "voice-of-triumph-hitler-s-speeches-at-nuremberg",
      "rise-of-the-nsdap",
      "national-socialism-a-comprehensive-examination",
      "myth-of-the-20th-century"
    ]
  },
  "autocracy": {
    "photo": "mussolini",
    "role": "Duce, Italy",
    "idea": "Fascism as state, syndicate, spectacle",
    "bio": "The speeches are the source, not the later costume. Voce del Popolo is the primary text we stock. The Fash bundle is the shelf. José Antonio, Mosley, and the Spanish war sit next to him.",
    "bundle": "the-fash-bundle",
    "start": "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
    "more": [
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1"
    ]
  },
  "capitalist-fascism": {
    "photo": "mussolini",
    "role": "Duce, Italy",
    "idea": "Fascism as state, syndicate, spectacle",
    "bio": "The speeches are the source, not the later costume. Voce del Popolo is the primary text we stock. The Fash bundle is the shelf. José Antonio, Mosley, and the Spanish war sit next to him.",
    "bundle": "the-fash-bundle",
    "start": "voce-del-popolo-mussolini-as-revealed-in-his-political-speeches",
    "more": [
      "buf-oswald-mosley-and-british-fascism",
      "jose-antonio-fascist",
      "gaddafi-s-the-green-book",
      "fourth-political-theory",
      "why-we-fight-manifesto-of-the-european-resistance",
      "archeofuturism-european-visions-of-the-post-catastrophic-age",
      "il-duce-massimo-vol-1"
    ]
  },
  "conservatism": {
    "photo": "spengler",
    "role": "Philosopher of history",
    "idea": "Cultures as living forms",
    "bio": "Decline of the West is the big book; Prussianism and Socialism is the political short. The Spengler bundle is the shelf. Yockey and Jünger sit next to him.",
    "bundle": "the-spengler-bundle",
    "start": "decline-of-the-west-two-volumes-in-one",
    "more": [
      "prussianism-and-socialism",
      "imperium-the-philosophy-of-history-and-politics",
      "the-ernst-junger-bundle",
      "the-ernst-junger-bundle"
    ]
  },
  "neo-liberalism": {
    "photo": "aurelius",
    "role": "Emperor, Stoic",
    "idea": "Duty, inner rule, a state that holds",
    "bio": "Meditations is the book. The Stoic bundle is the shelf. The Prince is the colder manual of the same problem: how to govern when the age is not helping you.",
    "bundle": "the-stoic-bundle",
    "start": "meditations-complete-and-unabridged",
    "more": [
      "consolation-of-philosophy",
      "the-prince-second-edition"
    ]
  },
  "classical-liberalism": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  },
  "authoritarian-capitalism": {
    "photo": "yockey",
    "role": "Theorist of Imperium",
    "idea": "The West as a subject, not a market",
    "bio": "Yockey wrote Imperium in 1948 as a philosophy of history with a political will. The Yockey bundle is the shelf. Spengler is the civilizational science underneath it.",
    "bundle": "the-francis-p-yockey-bundle",
    "start": "imperium-the-philosophy-of-history-and-politics",
    "more": [
      "lost-writings-of-francis-parker-yockey",
      "world-in-flames-the-shorter-writings-of-francis-parker-yockey",
      "enemy-of-europe",
      "decline-of-the-west-two-volumes-in-one",
      "decline-of-the-west-two-volumes-in-one",
      "prussianism-and-socialism"
    ]
  },
  "state-capitalism": {
    "photo": "stalin",
    "role": "General Secretary, USSR",
    "idea": "Administered Marxism-Leninism",
    "bio": "Stalin is what happens when the left stops debating and starts planning. Foundations of Leninism is the pocket manual. The communism bundle is the shelf. Mao is the next door if you want the peasant-cadre version.",
    "bundle": "the-communism-bundle",
    "start": "foundations-of-leninism",
    "more": [
      "state-and-revolution-revised",
      "what-is-to-be-done-revised",
      "communist-manifesto-revised",
      "philosophy-of-marx",
      "imperialism-the-highest-stage-of-capitalism-a-popular-outline",
      "revolution-betrayed",
      "little-red-book-sayings-of-chairman-mao"
    ]
  },
  "neo-conservatism": {
    "photo": "yockey",
    "role": "Theorist of Imperium",
    "idea": "The West as a subject, not a market",
    "bio": "Yockey wrote Imperium in 1948 as a philosophy of history with a political will. The Yockey bundle is the shelf. Spengler is the civilizational science underneath it.",
    "bundle": "the-francis-p-yockey-bundle",
    "start": "imperium-the-philosophy-of-history-and-politics",
    "more": [
      "lost-writings-of-francis-parker-yockey",
      "world-in-flames-the-shorter-writings-of-francis-parker-yockey",
      "enemy-of-europe",
      "decline-of-the-west-two-volumes-in-one",
      "decline-of-the-west-two-volumes-in-one",
      "prussianism-and-socialism"
    ]
  },
  "fundamentalism": {
    "photo": "guenon",
    "role": "Metaphysician",
    "idea": "The modern world as a rupture",
    "bio": "Guénon is not a campaign. The Crisis of the Modern World is the short book. Evola is the political traditionalist who took the same diagnosis into the street.",
    "bundle": "the-essential-evola-bundle",
    "start": "the-crisis-of-the-modern-world",
    "more": [
      "revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga",
      "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul",
      "men-among-the-ruins-postwar-reflections-of-a-radical-traditionalist",
      "doctrine-of-awakening-the-attainment-of-self-mastery-according-to-the-earliest-buddhist-texts"
    ]
  },
  "libertarian-capitalism": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  },
  "objectivism": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  },
  "totalitarian-capitalism": {
    "photo": "yockey",
    "role": "Theorist of Imperium",
    "idea": "The West as a subject, not a market",
    "bio": "Yockey wrote Imperium in 1948 as a philosophy of history with a political will. The Yockey bundle is the shelf. Spengler is the civilizational science underneath it.",
    "bundle": "the-francis-p-yockey-bundle",
    "start": "imperium-the-philosophy-of-history-and-politics",
    "more": [
      "lost-writings-of-francis-parker-yockey",
      "world-in-flames-the-shorter-writings-of-francis-parker-yockey",
      "enemy-of-europe",
      "decline-of-the-west-two-volumes-in-one",
      "decline-of-the-west-two-volumes-in-one",
      "prussianism-and-socialism"
    ]
  },
  "ultra-capitalism": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  },
  "anarcho-capitalism": {
    "photo": "nietzsche",
    "role": "Philosopher",
    "idea": "Rank, style, the herd as enemy",
    "bio": "Not a party. A demand on the self. Beyond Good and Evil and Zarathustra are the books; the Nietzsche bundle is how you actually read him here. Schopenhauer is the pessimist door he walked through; Evola is what some people did with him next.",
    "bundle": "the-nietzsche-bundle",
    "start": "beyond-good-and-evil",
    "more": [
      "thus-spake-zarathustra-a-book-for-all-and-none",
      "on-the-genealogy-of-morals-and-ecce-homo",
      "anti-christ",
      "will-to-power",
      "i-am-dynamite-a-life-of-nietzsche",
      "the-schopenhauer-bundle",
      "why-i-am-so-wise"
    ]
  }
};
